import {Box3, BoxGeometry, BufferAttribute, Object3D} from "three";
type Box3WithSize = Box3 & {size: { x: number, y: number, z: number }}


export const Utils = {
    setUv2(geometry: BoxGeometry) {
        const uv2 = new BufferAttribute(geometry.attributes.uv.array, 2);
        geometry.setAttribute("uv2", uv2);
    },
    formatNumberToPrice(number: number, currency = "₽", separator = " ") {
        return `${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)} ${currency}`;
    },
    mathRound(value: number, accuracy = 1000) {
        return Math.round(value * accuracy) / accuracy;
    },
    downloadImage(src: string, filename: string) {
        const a = document.createElement("a");
        a.download = filename || "img.jpeg";
        a.href = src;
        a.click();
        a.remove();
    },
    dateFormat(date: Date, delimiter = ".") {
        const DAY = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        const MONTH = date.getMonth() < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        return DAY + delimiter + MONTH + delimiter + date.getFullYear();
    },
    removeFirstNullFromNumbers(str: string) {
        let value = str;
        for (let i = 0; i < value.length; i++) {
            if (+value[i] === 0 && !Number.isNaN(+value[i + 1]) && Number.isNaN(+value[i - 1])) {
                value = value.slice(0, i) + value.slice(i + 1);
            }
        }
        return value;
    },
    myRound(number: number, precision = 1000) {
        return Math.round(number * precision) / precision
    },
    // openBlankLink(e, hash, type) {
    //     e?.stopPropagation();
    //     const domain = localStorage.getItem("conf_domain");
    //     const a = document.createElement("a");
    //     const typeURL = type === "pdf" ? "kp-" : "specification-";
    //     a.id = hash;
    //     a.target = "_blank";
    //     a.href = `${domain}/upload/pdfs/${typeURL}${hash}.pdf?t=${Date.now()}`;
    //
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(document.getElementById(hash));
    // },

    // openBlankForm(e, project) {
    //     e?.stopPropagation();
    //     const domain = localStorage.getItem("conf_domain");
    //     const form = document.createElement("form");
    //     form.id = project?.confcode;
    //     form.target = "_blank";
    //     form.method = "GET";
    //     form.action = `${domain}/configure/pdf/get_pdf.php`;
    //     const params = {
    //         confcode: project?.confcode,
    //     };
    //
    //     for (let i in params) {
    //         if (params.hasOwnProperty(i)) {
    //             const input = document.createElement("input");
    //             input.type = "hidden";
    //             input.name = i;
    //             input.value = params[i];
    //             form.appendChild(input);
    //         }
    //     }
    //
    //     document.body.appendChild(form);
    //     form.submit();
    //     document.body.removeChild(document.getElementById(project?.confcode));
    // },
    getClosest(number: number, array: []) {
        const tuples = array.map((val) => {
            return [val, Math.abs(val - number)];
        });
        return tuples.reduce((memo, val) => {
            return memo[1] < val[1] ? memo : val;
        })[0];
    },
    delay(ms: number) {
        return new Promise((res) => setTimeout(res, ms));
    },
    isTouchDevice() {
        try {
            const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

            const mq = (query: string) => window.matchMedia(query).matches;

            // @ts-ignore
            if (('ontouchstart' in window) || (typeof window.DocumentTouch !== "undefined" && document instanceof window.DocumentTouch)) {
                return true;
            }

            return mq(['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(''));
        } catch (e) {
            console.error('(Touch detect failed)', e);
            return false;
        }
    },
    getBoundaryGeometry(obj: Object3D) {
        let modelBoundingBox;
        modelBoundingBox = new Box3().setFromObject(obj) as Box3WithSize
        modelBoundingBox.size = {x: 0, y: 0, z: 0};
        modelBoundingBox.size.x = modelBoundingBox.max.x - modelBoundingBox.min.x;
        modelBoundingBox.size.y = modelBoundingBox.max.y - modelBoundingBox.min.y;
        modelBoundingBox.size.z = modelBoundingBox.max.z - modelBoundingBox.min.z;

        return modelBoundingBox;
    }
};

export const getSumWindowDebug = (windowDebug: boolean, price: number, count: number) => {
    return windowDebug ? ` (шт. ${price} р., сумма ${price * count} р.)` : ''
}
